import _ from 'lodash'
import { loading, blankResponseArray } from '../constants'
import { ResponseArray } from '../types'
import {
  IInquiry,
  IInquiryAddress,
  IInquiryContact,
  IInquiryItem,
  IInquiryParty,
  ISearchFilters,
} from './types'

export const blankInquiryAddress: IInquiryAddress = {
  Name: '',
  Address1: '',
  Address2: '',
  City: '',
  State: '',
  Zip: '',
  Phone: '',
  Country: 'US',
  Email: '',
  FirstName: '',
  LastName: '',
}

export const blankInquiryParty: IInquiryParty = {
  PartnerNumber: '',
  Name: '',
  Address1: '',
  Address2: '',
  Phone: '',
  City: '',
  State: '',
  Zip: '',
  Country: '',
}

export const blankInquiryItem: IInquiryItem = {
  InquiryItemId: 0,
  MaterialNumber: '',
  Description: '',
  Quantity: 0,
  QuantityUnit: 'EA',
  Price: 0.0,
  Tax: 0.0,
  TotalPrice: 0.0,
}

export const blankInquiryArray: ResponseArray<IInquiry> = _.assign(
  [],
  blankResponseArray,
)

export const loadingInquiries: ResponseArray<IInquiry> = _.assign(
  [],
  blankInquiryArray,
  loading,
)

export const blankInquiry: IInquiry = {
  SalesOrderNumber: '',
  InquiryId: 0,
  InquiryDate: new Date(),
  CustomerNumber: '',
  CustomerName: '',
  BillToParty: _.merge({}, blankInquiryAddress),
  ShipToParty: _.merge({}, blankInquiryAddress),
  Total: 0,
  Currency: 'USD',
  CartItems: [],
  Items: [],
  Comments: [],
  CancelReason: '',
  Status: 'Pending',
}

export const blankInquiryContact: IInquiryContact = {
  JobName: '',
  Name: '',
  Phone: '',
  Email: '',
}

export const blankSearchFilters: ISearchFilters = {
  page: 1,
  sortBy: 'InquiryDate',
  sortDesc: true,
  salesOrderNumber: '',
  customerName: '',
  customerNumber: '',
  inquiryDate: '',
  keyTerm: '',
  inquiryId: '',
  salesRep: '',
  inquiryStatus: 'Open',
}
